import logo from "../images/logo-primary.svg";
export function Header({ user, changeSection, username}) {

  const handleClick = () => {
    changeSection("login");
  }

  const handleClickProfile = () => {
    changeSection("profile");
  }

  return (
    <>
      <header className="o-header">
        <div className="o-header__cntr">
          <div className="container">
            <div className="bx username">
              {username || "Usuario anonimo"}
            </div>
            <div className="bx">
              {!user && <button className="btnBlue-m" onClick={() => handleClick()}>IDENTIFICATE</button>}
              {user && <button className="btnBlue-m" onClick={() => handleClickProfile()}>ZONA CLIENTE</button>}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
